// store/analyticsContentCacheStore.ts
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AnalyticsContentCacheStore {
  cache: Record<string, any>
  hydrated: boolean
  setCache: (key: string, data: any) => void
  getCache: (key: string) => any
  setHydrated: (value: boolean) => void
  clear: () => void
}

export const useAnalyticsContentCacheStore = create<AnalyticsContentCacheStore>()(
  persist(
    (set, get) => ({
      cache: {},
      hydrated: false,
      setCache: (key, data) => {
        set(state => ({
          cache: { ...state.cache, [key]: data }
        }))
      },
      getCache: key => {
        const value = get().cache[key]
        return value
      },
      setHydrated: value => {
        set({ hydrated: value })
      },
      clear: () => set({ cache: {}, hydrated: false }) 
    }),
    {
      name: 'analytics-content-cache',
      onRehydrateStorage: () => {
        return (state) => {
          state?.setHydrated(true)
        }
      }
    }
  )
)
